import moment from "moment";

import { addBaseline, getBaseline, getNormalizationTags } from "api/baseline";

import getLogger from "utils/logger.util";
import { formatlocaltoTimezone, isNumberType } from "utils/utils";
import { InputErrorStrings } from "constants/constantStrings";
import { ADD_BASELINE_DATE_FORMAT } from "constants/globalConstants";

export const getModalDataWithTagsMapping = async (modalData, tagsAsObj, editBaselineId, editBaselineType) => {
  let updatedData = JSON.parse(JSON.stringify(modalData));
  try {
    const { data } = await getNormalizationTags();
    if (data) {
      const baselineTags = updatedData.NormalizationTags;
      const NormalizationTags = {};
      Object.keys(baselineTags).forEach(tagName => {
        const mappedTagKey = data[tagName];
        NormalizationTags[tagName] = { ...baselineTags[tagName], tag: tagsAsObj[mappedTagKey] };
      });
      updatedData = { ...updatedData, NormalizationTags };
      if (editBaselineId) {
        const baselineData = await getBaselineDataById(editBaselineId, NormalizationTags, editBaselineType);
        updatedData = { ...updatedData, ...baselineData };
      }
    }
  } catch (err) {
    getLogger().log("Error while fetching tags mapping..", err);
  }
  return updatedData;
};

export const parseBaslineTagsValue = (tags, Values, Date, TimeStamp) => {
  const NormalizationTags = { ...tags };
  for (const [key, value] of Object.entries(Values)) {
    if (NormalizationTags[key]) {
      NormalizationTags[key].value = value?.toString() || null;
      NormalizationTags[key].error = value === null ? InputErrorStrings.required : "";
    }
  }

  return { NormalizationTags, Values, Date, TimeStamp };
};

const getBaselineCopyTitle = name => {
  const arr = name.split("_");
  let index = 1;
  if (isNumberType(arr[arr.length - 1])) {
    index += parseInt(arr[arr.length - 1]);
  }
  return name + "_" + index;
};

export const getBaselineDataById = async (baselineId, NormalizationTags, editBaselineType) => {
  try {
    const { data } = await getBaseline(baselineId, editBaselineType);
    if (data) {
      const Values = data.tags;
      Values.forEach(({ tagId, value }) => (NormalizationTags[tagId].value = value?.toString()));
      return {
        Title: getBaselineCopyTitle(data.Name),
        Type: data.Type,
        Values,
        NormalizationTags,
        BaselineValuesSetting: "timestamp",
        RowClicked: "true",
        Date: new Date(formatlocaltoTimezone(data.Date, data.Timezone)),
        TimeStamp: parseInt(new Date(data.Date).valueOf() / 1000)
      };
    }
  } catch (err) {
    getLogger().log("Error while fetching tags mapping..", err);
  }
};

const getAddBaselinePayload = modalData => {
  const normalizationTags = modalData.NormalizationTags;
  const normalizationTagValues = Object.entries(normalizationTags).map(tag => {
    const tagList = { TagId: tag[1].tagName, Value: tag[1].value };
    return tagList;
  });
  const dateTime = modalData.TimeStamp ? modalData.TimeStamp : Math.floor(new Date().getTime() / 1000);
  const formattedDate = moment.unix(dateTime).format(ADD_BASELINE_DATE_FORMAT);
  return {
    Name: modalData.Title,
    Date: formattedDate,
    Timezone: modalData.Timezone,
    Tags: normalizationTagValues
  };
};

export const addNewBaseline = async modalData => {
  let newBaselineData = null;
  try {
    const payload = getAddBaselinePayload(modalData);
    newBaselineData = await addBaseline(payload);
  } catch (err) {
    getLogger().error("Error while fetching tags mapping..", err);
  }
  return newBaselineData;
};
